<template>
  <div class="box" id="minePage">
    <top-header></top-header>
    <top-banner v-if="isLandscape && isRouteMine"></top-banner>
    <notice v-if="isLandscape && isRouteMine"></notice>
    <div class="content">
      <img
        v-if="!isLandscape && userbg"
        class="content-bg"
        :src="userbg"
        alt="userbg"
      />
      <div class="pc-header" v-if="isLandscape" @click="backToHome">
        <Icon class="back" name="right"></Icon>
        <span>{{ letter.v3Shop }}</span>
      </div>
      <div class="content-container">
        <div class="left">
          <img
            v-if="isLandscape && userbg"
            class="content-bg"
            :src="userbg"
            alt="userbg"
          />

          <div class="acount-top flex-between" v-if="!isLandscape">
            <Icon class="back" name="right" @click="backToHome"></Icon>
            <button
              class="role-switch flex-center"
              v-if="!isInWebview"
              @click="handleGoLogOut"
            >
              <span class="role-switch-text">{{ letter.logout }}</span>
            </button>
          </div>
          <div class="account-info">
            <img
              class="account-avatar"
              v-if="userAvatar"
              :src="userAvatar"
              alt="game-logo"
            />
            <p class="account-name">{{ userName }}</p>
            <div class="safe-tip flex-center">
              <Icon
                class="safe-ico"
                name="people-safe"
                @click="backToHome"
              ></Icon>
              <span>{{ letter.v3SafeToUse }}</span>
            </div>
            <button
              v-if="isLandscape"
              class="role-switch flex-center"
              @click="handleGoLogOut"
            >
              <span class="role-switch-text">{{ letter.v3Logout }}</span>
            </button>
            <!-- 还没接入，先隐藏 -->
            <!-- <div class="login-status flex-center" @click="rememberStatusHandle">
            <div class="safe-checkbox">
              <Icon
                v-show="isRememberStatus"
                class="checked-ico"
                name="check-small"
              ></Icon>
            </div>
            <span>{{ letter.v3RememberLoginStatus }}</span>
          </div> -->
          </div>
          <div
            class="switch-version"
            v-if="showSwitchVersion"
            @click="switchVersion"
          >
            <em class="switch-icon"></em>
            <span class="switch-text"> {{ letter.v3SwitchOldVersion }}</span>
          </div>
        </div>
        <div class="right">
          <div class="account-btn-list">
            <div class="account-btn" @click="accountHandle('coupon')">
              <Icon class="account-btn-ico" name="ticket" />
              <p class="account-btn-text">{{ letter.v3MyCoupons }}</p>
              <em class="red-dot" v-if="showRedDot"></em>
            </div>
            <div
              v-if="visibleRights"
              class="account-btn"
              @click="accountHandle('vip')"
            >
              <Icon class="account-btn-ico" name="vip" />
              <p class="account-btn-text">{{ letter.v3BenefitsCenter }}</p>
            </div>
            <div
              v-if="showTimeAwardList.length"
              class="account-btn"
              @click="accountHandle('activity')"
            >
              <Icon class="account-btn-ico" name="time" />
              <p class="account-btn-text">
                {{ letter.limitedTimeActivityTitle }}
              </p>
            </div>
            <!-- 还没接入，先隐藏 -->
            <!-- <div class="account-btn" @click="accountHandle('order')">
              <Icon class="account-btn-ico" name="bill" />
              <p class="account-btn-text">订单查询</p>
            </div> -->
            <div
              v-if="roleId"
              class="account-btn"
              @click="accountHandle('service')"
            >
              <Icon class="account-btn-ico" name="headset-one" />
              <p class="account-btn-text">
                {{ letter.v3ContactCustomerService }}
              </p>
            </div>

            <div
              v-if="officialLink"
              class="account-btn"
              @click="accountHandle('website')"
            >
              <Icon class="account-btn-ico" name="home" />
              <p class="account-btn-text">{{ letter.enterOfficial }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 优惠券 -->
    <transition name="fade">
      <div
        class="popup-shadow"
        style="z-index: 8"
        v-show="isShowGameCouponPopup"
      ></div>
    </transition>
    <transition :name="tranName">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :languages="letter"
        @closeCouponPopup="hideGameCouponPopup"
      ></coupon-list-popup>
    </transition>
    <!-- 全局提示弹窗 -->
    <PopupWindow
      v-if="globalTipsVisible"
      type="tips"
      :languages="letter"
      :content="globalTipsContent"
      textAlign="center"
      @onConfirm="globalTipsVisible = false"
      @onCancel="globalTipsVisible = false"
    ></PopupWindow>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
  </div>
</template>

<script>
import Loading from '@components/officialTopupNew/Loading.vue';
import TopHeader from '@components/officialTopupNew/TopHeader.vue';
import CouponListPopup from '@components/officialTopupNew/coupon/CouponListPopup.vue';
import TopBanner from '@components/officialTopupNew/TopBanner.vue';
import Notice from '@components/officialTopupNew/activity/Notice.vue';
import { mapGetters, mapState } from 'vuex';
import { SET_GLOBAL_TIPS_VISIBLE } from '@store/officialTopupNew';
import account from '@mixins/officialTopupNew/account';
import style from '@mixins/officialTopupNew/style';

import globalConfig from '@utiles/officialStore/globalConfig';
import switchVersion from '@mixins/officialTopupNew/switchVersion';
export default {
  name: 'webStoreMinePage',
  mixins: [account, style, switchVersion],
  data() {
    return {
      isRememberStatus: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      letter: state => state.letter,
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      lang: state => state.lang,
      displayName: state => state.login.displayName,
      indexBannerList: state => state.activity.indexBannerList,
      lampList: state => state.activity.lampList,
      rightsLink: state => state.page.rightsLink,
      picList: state => state.page.picList,
      globalTipsVisible: state => state.globalTipsVisible,
      globalTipsContent: state => state.globalTipsContent,
      isInWebview: state => state.isInWebview,
      gameCouponEnableList: state => state.coupon.gameCouponEnableList,
      roleId: state => state.roleId
    }),
    ...mapGetters(['showTimeAwardList']),
    userAvatar() {
      return this.picList?.avatar;
    },
    userbg() {
      return this.picList?.userbg;
    },
    userName() {
      // 20240725 需求人: 邓智轩 特殊处理：顽星域名账号展示隐藏前缀 以DISPLAY_NAME字段作为账号显示名称
      if (globalConfig.getMainHost() === 'playplanetgame.com') {
        return this.displayName;
      } else {
        return this.loginAccount;
      }
    },
    isRouteMine() {
      return this.$route.name === 'mine';
    },
    globalTipsVisible: {
      get() {
        return this.$store.state.globalTipsVisible;
      },
      set(val) {
        this.$store.commit(SET_GLOBAL_TIPS_VISIBLE, val);
      }
    },
    showRedDot() {
      return this.gameCouponEnableList?.length > 0;
    }
  },
  methods: {
    backToHome() {
      this.$router.push('/');
    }
  },
  components: {
    Loading,
    TopHeader,
    TopBanner,
    Notice,
    CouponListPopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.box {
  box-sizing: border-box;
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
}

.content {
  position: relative;
  width: 100%;
  // min-height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 180px 40px $tabbarHeight;
  background-color: #ffffff;

  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
    margin-top: -20px;
  }
  &-container {
    position: relative;
  }
}
.acount-top {
  width: 100%;
  display: flex;

  .back {
    width: 29px;
    height: 29px;
    cursor: pointer;
    transform: rotate(180deg);
  }
}
.role-switch {
  flex-shrink: 0;
  min-width: 150px;
  height: fit-content;
  background-color: #ffffff;
  border-radius: 9px;
  padding: 20px;
  border: solid 1px #e8e8e8;
  cursor: pointer;

  .role-switch-text {
    line-height: 1.2;
    font-size: 22px;
    color: #333333;
  }
}
.account-info {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .account-avatar {
    flex-shrink: 0;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .account-name {
    margin-top: 17px;
    font-size: 28px;
    font-weight: bold;
    line-height: 1.5;
  }
}

.safe-tip {
  margin-top: 20px;
  color: #666666;
  font-size: 20px;

  .safe-ico {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.login-status {
  margin-top: 20px;
  color: #666666;
  font-size: 20px;
  cursor: pointer;
  .safe-checkbox {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: solid 1px #666666;
    margin-right: 10px;
    .checked-ico {
      width: 24px;
      height: 24px;
    }
  }
}

.account-btn-list {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 60px;

  .account-btn {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    border-radius: 9px;
    border: solid 1px #e8e8e8;
    cursor: pointer;

    .account-btn-ico {
      position: absolute;
      margin: 0 20px;
      width: 40px;
      height: 40px;
      color: $themeColor;
    }

    .account-btn-text {
      line-height: 1.2;
      padding: 0 80px;
      text-align: center;
      flex: 1;
      font-size: 24px;
      color: #333333;
    }
  }
  .account-btn + .account-btn {
    margin-top: 22px;
  }
}

.pc-header {
  display: none;
}

.red-dot {
  display: block;
  position: absolute;
  right: -2px;
  top: -2px;
  width: 16px;
  height: 16px;
  background-color: #ff2800;
  border-radius: 50%;
}

.left {
  position: relative;
}

#ssr-page.landscape {
  .box {
    background-color: $backgroundColor;
  }
  .content {
    max-width: 1200px;
    padding-top: 60px;
    margin: 0 auto;
    background-color: $backgroundColor;

    .content-container {
      display: flex;
      .left {
        flex-shrink: 0;
        width: 440px;
        height: 470px;
        background-color: $moduleBackgroundColor;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 40px;

        .content-bg {
          width: 440px;
          border-radius: 20px;
          margin-top: 0;
        }
        .switch-version {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 34px;
          // background: url($commonImg + 'switch-version-bg.png') no-repeat;
          // background-size: cover;
          border-top-right-radius: 20px;
          border-bottom-left-radius: 20px;
          border-top-left-radius: 20px;
          cursor: pointer;
          font-size: 16px;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.5);
          padding: 0 15px;
          .switch-icon {
            display: block;
            width: 22px;
            height: 22px;
            margin-right: 5px;
            background: url($commonImg + 'switch-version.png') no-repeat;
            background-size: cover;
          }
          .switch-text {
            font-size: 18px;
          }
        }
      }
      .right {
        margin-left: 40px;
        flex: 1;
      }
    }
  }
  .pc-header {
    width: fit-content;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-bottom: 30px;
    .back {
      width: 29px;
      height: 29px;
      transform: rotate(180deg);
      margin-right: 20px;
    }
  }

  .account-info {
    .account-avatar {
      margin-right: 0;
    }

    .account-name {
      margin-top: 40px;
      font-size: 22px;
      line-height: 1.5;
    }
  }

  .safe-tip {
    font-size: 18px;
    .safe-ico {
      width: 30px;
      height: 30px;
    }
  }

  .role-switch {
    margin-top: 40px;
    min-width: 108px;
    padding: 10px;
    cursor: pointer;

    .role-switch-text {
      font-size: 20px;
    }
  }

  .account-btn-list {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 20px;
    grid-column-gap: 39px;
    margin-top: 0;

    .account-btn {
      width: 306px;
      .account-btn-ico {
        margin: 0 26px;
      }

      .account-btn-text {
        font-size: 20px;
      }
    }
    .account-btn + .account-btn {
      margin-top: 0;
    }
  }
}

/* iPad横向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .box {
    overflow: visible;
    padding-bottom: 0;
  }
  .content {
    widows: 1200px;
  }
}
</style>
